import React from 'react';
import { 
  Package, 
  Star, 
  Hash, 
  Image,
  TrendingUp,
  Clock,
  Zap
} from 'lucide-react';

const SpecialsStatsCard = ({ data = [] }) => {
  // Calcular estatísticas
  const totalSpecials = data.length;
  const popularSpecials = data.filter(item => item.is_popular).length;
  const specialsWithImage = data.filter(item => item.image).length;
  const averageWeight = data.length > 0 ? 
    (data.reduce((sum, item) => sum + (parseFloat(item.weight) || 0), 0) / data.length).toFixed(1) : '0';

  // Especiais modificados recentemente (últimos 7 dias)
  const recentlyModified = data.filter(special => {
    if (!special.modified_at && !special.updated_at) return false;
    const modifiedDate = new Date(special.modified_at || special.updated_at);
    const weekAgo = new Date();
    weekAgo.setDate(weekAgo.getDate() - 7);
    return modifiedDate > weekAgo;
  }).length;

  // Porcentagem de especiais populares
  const popularPercentage = totalSpecials > 0 ? ((popularSpecials / totalSpecials) * 100).toFixed(1) : 0;

  const cards = [
    {
      title: "Total de Especiais",
      value: totalSpecials,
      icon: <Package className="h-5 w-5" />,
      color: "border-purple-500 text-purple-600",
      bgColor: "bg-purple-50"
    },
    {
      title: "Especiais Populares",
      value: popularSpecials,
      subtitle: `${popularPercentage}% do total`,
      icon: <Star className="h-5 w-5" />,
      color: "border-yellow-500 text-yellow-600",
      bgColor: "bg-yellow-50"
    },
    {
      title: "Com Imagem",
      value: specialsWithImage,
      subtitle: `${totalSpecials > 0 ? ((specialsWithImage / totalSpecials) * 100).toFixed(1) : 0}% com foto`,
      icon: <Image className="h-5 w-5" />,
      color: "border-green-500 text-green-600",
      bgColor: "bg-green-50"
    },
    {
      title: "Peso Médio",
      value: `${averageWeight}`,
      subtitle: recentlyModified > 0 ? `${recentlyModified} modificados` : "Últimos 7 dias",
      icon: <Hash className="h-5 w-5" />,
      color: "border-blue-500 text-blue-600",
      bgColor: "bg-blue-50"
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mt-6">
      {cards.map((card, index) => (
        <div 
          key={index}
          className={`bg-white/90 backdrop-blur rounded-lg p-4 shadow-md border-l-4 ${card.color.split(' ')[0]} hover:shadow-lg transition-shadow duration-200`}
        >
          <div className="flex items-center justify-between">
            <div className="flex-1">
              <p className="text-sm font-medium text-gray-500 mb-1">
                {card.title}
              </p>
              <p className={`text-2xl font-bold ${card.color.split(' ')[1]}`}>
                {card.value}
              </p>
              {card.subtitle && (
                <p className="text-xs text-gray-400 mt-1">
                  {card.subtitle}
                </p>
              )}
            </div>
            <div className={`${card.bgColor} p-3 rounded-full ${card.color}`}>
              {card.icon}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

// Componente adicional para breakdown detalhado (opcional)
export const SpecialsBreakdown = ({ data = [] }) => {
  const categoryBreakdown = data.reduce((acc, special) => {
    const category = special.category || 'Sem categoria';
    acc[category] = (acc[category] || 0) + 1;
    return acc;
  }, {});

  return (
    <div className="bg-white/90 backdrop-blur rounded-lg p-4 shadow-md border-l-4 border-indigo-500 col-span-full mt-4">
      <h3 className="text-sm font-medium text-gray-500 mb-3">
        Distribuição por Categoria
      </h3>
      <div className="space-y-2">
        {Object.entries(categoryBreakdown).map(([category, count]) => {
          const percentage = data.length > 0 ? ((count / data.length) * 100).toFixed(1) : 0;
          return (
            <div key={category} className="flex items-center justify-between">
              <div className="flex items-center space-x-2">
                <div className="w-3 h-3 rounded-full bg-gradient-to-r from-purple-400 to-purple-600"></div>
                <span className="text-sm text-gray-700">{category}</span>
              </div>
              <div className="flex items-center space-x-2">
                <span className="text-sm font-medium text-gray-900">{count}</span>
                <span className="text-xs text-gray-500">({percentage}%)</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SpecialsStatsCard;